import { useHmoPlan } from '@hook'
import { DeleteModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'

type Props = {
  id?: string
  onClose: () => void
}

export const RemovePlan = ({ onClose, id }: Props) => {
  const { deleteHmoPlan } = useHmoPlan()
  const [isLoading, setIsLoading] = useState(false)

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await deleteHmoPlan({ id: id || '' })
      onClose()
      showToast('Plan deleted successfully')
      setIsLoading(false)
    } catch (error) {
      getError(error)
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <DeleteModal
      description="Confirm that you want to delete this Plan"
      handleSubmit={handleDelete}
      isLoading={isLoading}
      onClose={onClose}
      title="Delete Plan"
    />
  )
}
